// removed by extract-text-webpack-plugin
module.exports = {"background-grey":"#f6f6f6","light-grey":"#d4d4d4","grey":"#707070","desktop":"1366px","fastest":".15s","linear":"cubic-bezier(0, 0, 1, 1)","tabs":"_2RYNqcLWtyLSIXEcSadUZX","withIcons":"_1BblsMLE_dDmpjTxYul_5W","withSteptracker":"X172VEm4hNsaq3eEGgLde","horizontal":"_3s44Fp-hCLC5oLZ8Tm1klr"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tabs/TabsSection/Tabs/Tabs.css
// module id = 1146
// module chunks = 0